import React from 'react'
import Container from '@material-ui/core/Container';
import terreno from '../../assets/terreno3.png';

const Section1 = () => {

  return (
    <div id='terreno' className='section casazen'>
        <Container className='relative flex flexCol'>
          
        <div className="floatTitle shadow">
              <h2>Terreno</h2>
              <p>Lote de 15 m. de frente x 38.62 m. de fondo<br />Total: 579.30 m2
              </p>
            </div>
              <img className='terrenoImg view' src={terreno} alt="Terreno"/>
        </Container>
    </div>
  )
}

export default Section1